import { createIcon } from './icon-utils';

export const InsertTableIcon = createIcon({
  path: 'M4.875 12.75v5.624c0 .414.336.75.75.75h5.625V12.75H4.875zm0-1.5h6.375V4.873H5.625c-.414 0-.75.336-.75.75v5.625zm14.25 1.5H12.75v6.374h5.625c.414 0 .75-.336.75-.75V12.75zm0-1.5V5.623c0-.414-.336-.75-.75-.75H12.75v6.375h6.375zm-13.5-7.876h12.75c1.243 0 2.25 1.008 2.25 2.25v12.75c0 1.243-1.007 2.25-2.25 2.25H5.625c-1.243 0-2.25-1.007-2.25-2.25V5.624c0-1.242 1.007-2.25 2.25-2.25z',
  viewBox: '0 0 24 24',
});
